import { faBars } from '@fortawesome/pro-solid-svg-icons/faBars';
import { faBomb } from '@fortawesome/pro-solid-svg-icons/faBomb';
import { faCaretDown } from '@fortawesome/pro-solid-svg-icons/faCaretDown';
import { faRectangleHistory } from '@fortawesome/pro-solid-svg-icons/faRectangleHistory';
import { faXmark } from '@fortawesome/pro-solid-svg-icons/faXmark';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
	GetItemCounts,
	SendsPageItemType,
	useAccountUser,
	useInfiniteShortListSendsPage,
} from '@ukpostbox/client-data';
import {
	ContentBlock,
	ComboBoxFilterInput,
	FlexAlign,
	FlexGap,
	FlexJustify,
	InfiniteLoadTrigger,
	SectionNavigationEntry,
	SectionNavigationGroup,
	StackVertical,
	useComboBoxKeyboardNavigation,
	useFilter,
	useLayout,
	useOutsiderDetector,
} from '@ukpostbox/frontend-framework';
import React, { useEffect, useRef, useState } from 'react';
import { useNavigate, useParams } from 'react-router';
// @ts-ignore
import ss from '@ukpostbox/frontend-framework/lib/Components/Navigation/SectionNavigation/SectionNavigation.module.scss';

type StandaloneSendTemplateNavigationType = {
	containerRef?: any;
};

function StandaloneSendTemplateNavigation(props: StandaloneSendTemplateNavigationType) {
	const navigate = useNavigate();

	const { data: userData } = useAccountUser();

	const [userPageCount, setUserPageCount] = useState<number>(0);
	const [sectionOpen, setSectionOpen] = useState<boolean>(false);

	const { pageId } = useParams();
	const { isTiny, isSmall, isMedium } = useLayout();

	const filterRef: any = useRef<HTMLInputElement>(null);
	const menuRef: any = useRef(null);
	const menuTriggerRef: any = useRef(null);
	useOutsiderDetector(menuRef, () => (sectionOpen ? setSectionOpen(false) : null));

	const [itemCounts, setItemCounts] = useState<any>({ loaded: 0, total: 0 });

	const { status, data, error, isFetchingNextPage, fetchNextPage, hasNextPage, isStale, isRefetching } =
		useInfiniteShortListSendsPage();

	const { filterItems, filterValue, FilterData, ResetFilter } = useFilter({ filterData: data, filterKey: 'title' });
	const { HandleInputKeys } = useComboBoxKeyboardNavigation({
		itemClassName: '',
		itemContainerSelector: null,
		resetCallback: ResetFilter,
	});

	const CountValidUserPages = () => {
		if (data) {
			let count = 0;

			data.pages.forEach((group: any) =>
				group.data.forEach((pageEntry: SendsPageItemType) => {
					if (pageEntry.isActive || !pageEntry.isDeleted) {
						count += 1;
					}
				}),
			);

			setUserPageCount(count);
		}
	};

	const CheckPageActive = () => {
		if (
			!pageId &&
			data &&
			data?.pages[0].totalRecords > 0 &&
			!userData?.roles.includes('SENDS_PAGE_ADMIN') &&
			!userData?.roles.includes('MANAGER')
		) {
			navigate(`/sends-page/${data.pages[0].data[0].id}`);
		}
	};

	useEffect(() => {
		CheckPageActive();
		CountValidUserPages();
		if (data) {
			setItemCounts(GetItemCounts(data as any));
		}
	}, [pageId, data]);

	return (
		<nav
			className={`${ss['section-navigation']} ${ss['section-navigation-rounded']} ${sectionOpen ? 'open' : ''}`}
			ref={menuRef}
		>
			<div className={`${ss['section-navigation-header']} ${isTiny || isSmall || isMedium ? 'mb-sm' : ''}`}>
				<div
					className={ss['section-navigation-title']}
					onClick={() => setSectionOpen(!sectionOpen)}
					onKeyDown={(e) => (e.key === 'Enter' ? setSectionOpen(!sectionOpen) : undefined)}
					role='button'
					tabIndex={0}
					ref={menuTriggerRef}
				>
					<FontAwesomeIcon icon={sectionOpen ? faXmark : faBars} style={{ marginInlineEnd: '.75em' }} />
					<h6 className='m-0 sub-heading'>
						Your Pages {(isTiny || isSmall || isMedium) && <>({userPageCount})</>}
					</h6>
					<FontAwesomeIcon icon={faCaretDown} style={{ marginInlineStart: 'auto' }} />
				</div>
			</div>

			<div
				className={ss['section-navigation-entries']}
				style={{ paddingTop: isTiny || isSmall || isMedium ? `${menuTriggerRef.current?.offsetHeight}px` : 0 }}
			>
				{status === 'pending' ? (
					<div className='content-loader content-fader'>
						<div
							style={{
								height: '3em',
								marginInline: isTiny || isSmall || isMedium ? 'var(--md-negative-unit)' : '0',
							}}
						/>
						<div
							style={{
								height: '3em',
								marginInline: isTiny || isSmall || isMedium ? 'var(--md-negative-unit)' : '0',
							}}
						/>
						<div
							style={{
								height: '3em',
								marginInline: isTiny || isSmall || isMedium ? 'var(--md-negative-unit)' : '0',
							}}
						/>
						<div
							style={{
								height: '3em',
								marginInline: isTiny || isSmall || isMedium ? 'var(--md-negative-unit)' : '0',
							}}
						/>
						<div
							style={{
								height: '3em',
								marginInline: isTiny || isSmall || isMedium ? 'var(--md-negative-unit)' : '0',
							}}
						/>
						<div
							style={{
								height: '3em',
								marginInline: isTiny || isSmall || isMedium ? 'var(--md-negative-unit)' : '0',
							}}
						/>
						<div
							style={{
								height: '3em',
								marginInline: isTiny || isSmall || isMedium ? 'var(--md-negative-unit)' : '0',
							}}
						/>
						<div
							style={{
								height: '3em',
								marginInline: isTiny || isSmall || isMedium ? 'var(--md-negative-unit)' : '0',
							}}
						/>
					</div>
				) : status === 'error' ? (
					<ContentBlock error title={error.name} content={error.message} />
				) : (
					<SectionNavigationGroup>
						{itemCounts.total > 14 && (
							<div className='pt-sm pl-sm pr-sm'>
								<ComboBoxFilterInput
									title='Template Filter'
									onClick={() => null}
									placeholder='Filter...'
									inputRef={filterRef}
									filterValue={filterValue}
									active
									loading={false}
									resetCallback={() => ResetFilter()}
									onBlur={(e: any) => console.log('blur', e)}
									onChange={(e: any) => FilterData(e)}
									onKeyDown={(e: any) => HandleInputKeys(e)}
									onFocus={(e: any) => console.log('filterFocusCallback', e)}
								/>
							</div>
						)}

						{filterItems &&
							filterItems.map((pageEntry: SendsPageItemType) => (
								<SectionNavigationEntry
									key={`pagesNav-${pageEntry.id}`}
									title={pageEntry.title}
									path={`/sends-page/${pageEntry.id}`}
									callback={() => setSectionOpen(false)}
								/>
							))}

						{filterItems.length === 0 && itemCounts.total > 0 && (
							<StackVertical
								gap={FlexGap.ExtraSmall}
								align={FlexAlign.Center}
								justify={FlexJustify.Center}
								extraClass='feature-highlight p-lg  text-center'
							>
								<FontAwesomeIcon icon={faRectangleHistory} size='2x' />
								<h6 className='sub-heading mt-sm mb-xs'>No Matching Pages</h6>
							</StackVertical>
						)}

						{itemCounts.total === 0 && (
							<StackVertical
								gap={FlexGap.ExtraSmall}
								align={FlexAlign.Center}
								justify={FlexJustify.Center}
								extraClass='feature-highlight p-lg  text-center'
							>
								<FontAwesomeIcon icon={faBomb} size='2x' />
								<h6 className='sub-heading mt-sm mb-xs'>No Pages Exist</h6>
							</StackVertical>
						)}

						{itemCounts.total > 0 && filterItems.length < itemCounts.total && (
							<InfiniteLoadTrigger
								loaded={itemCounts.loaded}
								totalCount={itemCounts.total}
								hasNextPage={hasNextPage}
								fetchNextPage={fetchNextPage}
								isFetchingNextPage={isFetchingNextPage}
								isStale={isStale}
								isRefetching={isRefetching}
								extraClass='faded small'
								hideLabel
							/>
						)}
					</SectionNavigationGroup>
				)}
			</div>
		</nav>
	);
}

export default StandaloneSendTemplateNavigation;
